// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T21:56:39.430Z
// Property: Brookstone Apartments (ID: 6767906449167348)
// Collections: 16 amenities, 4 floorplans (live), 10 photos, 34 POIs, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162458",
  "multihub_property_id": "6767906449167348",
  "property_external_id": "5098665",
  "property_zillow_url": "https://www.zillow.com/apartments/bellefontaine-oh/brookstone-apartments/5Xp3Cf/",
  "property_apartments_url": "https://www.apartments.com/brookstone-apartments-bellefontaine-oh/hcywpm2/",
  "property_google_business_url": "https://www.google.com/maps/place/Brookstone+Apartments/data=!4m2!3m1!1s0x0:0xce6cedea30e68156?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "58535597147",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": "5098665",
  "property_status": null,
  "property_slug": "brookstone-apartments",
  "property_name": "Brookstone Apartments",
  "property_website_url": "https://www.brookstoneapartmentliving.com/",
  "property_domain": "https://www.brookstoneapartmentliving.com/",
  "property_address": "500 Gunntown Rd",
  "property_full_address": "500 Gunntown Rd, Bellefontaine, OH 43311",
  "property_address_1": "500 Gunntown Rd",
  "property_address_2": null,
  "property_address_city": "Bellefontaine",
  "property_address_state": "OH",
  "property_address_zip_full": "43311-9010",
  "property_address_zip": "43311",
  "property_address_country": "US",
  "property_address_county": "Logan County",
  "property_neighborhood_address": "Ohio South Area",
  "property_address_latitude": "40.3274862",
  "property_address_longitude": "-83.75410839999999",
  "property_email": "bah@dietzpropertygroup.com",
  "property_phone": "(937) 592-9393",
  "property_call_tracking_phone": "937-592-9393",
  "property_company_name": "Dietz Property Group",
  "property_company_url": "https://dietzpropertygroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Brookstone Apartments in Bellefontaine, OH, experience comfort in our thoughtfully designed two and three-bedroom homes. Enjoy delightful amenities like high-speed internet, generous balconies, and a playful playground, all under the care of our professional management team. Your perfect living space awaits—check availability or schedule a tour today!",
  "property_long_description": "Welcome to Brookstone Apartments, your charming retreat located in the heart of Bellefontaine, OH! Our community offers a variety of spacious and thoughtfully designed floor plans, featuring two-bedroom and three-bedroom options tailored to meet your lifestyle needs. Each apartment is equipped with modern amenities to ensure comfort and convenience. Enjoy Central Heat & Air Conditioning, high-speed internet access, and plush carpeting throughout your home. \n\nRelax on your private balcony or patio, or whip up culinary delights in a kitchen outfitted with sleek black appliances, including a dishwasher, microwave, and garbage disposal. Our pet-friendly community welcomes your furry companions, and with professional on-site management and controlled access, you can feel secure and at ease. \n\nFamilies will love our playground area, and with laundry facilities conveniently available, you won’t have to go far for your everyday needs. Plus, we offer flexible rent payment options to suit your budget and lifestyle. Located in an ideal area of Bellefontaine, you’ll enjoy easy access to shopping, dining, parks, and more.\n\nAt Brookstone Apartments, we strive to provide an inviting atmosphere that feels like home. Don’t miss out on the opportunity to become part of our vibrant community! **Find your new home today—browse our availability or schedule a tour to visit us!** Your perfect apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of an apartment building with balconies and green lawn.",
    "public_id": "019d63b1-674b-7546-b5ab-4baef2fe557e",
    "storage_key": "property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
    "width": 2048,
    "height": 1151
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "96",
  "property_year_built": "2000",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.79166666666666",
  "property_admin_fee": "150",
  "property_application_fee": "50",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions apply.",
  "property_pet_policy_description": "We welcome cats and dogs. We accept up to 2 pets per apartment home. There is a $200 non‑refundable pet fee per pet and $35 monthly pet rent per pet. Breed restrictions apply.",
  "property_petpolicy_info": "Pet Policy Type: Cat, Dogs\nPet Monthly Rent Min: $35\nPet Policy: Brookstone Apartments is a pet-friendly community. We proudly accept up to 2 pets per apartment home. There is a $200 non-refundable pet fee and a $35 monthly pet rent (both per pet). Please contact our Leasing Office for our full pet policy. Breed restrictions apply.\nPet Rent Basis: Per Pet\nMax Number of Pets: 2\nPet Policy Fee Min: $200",
  "property_online_leasing_url": "https://8966420.onlineleasing.realpage.com/#k=54381",
  "property_resident_portal_url": "https://brookstoneapartments.loftliving.com/login",
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63af-1d4a-77ea-ac33-9d75191b3b30.webp",
  "property_primary_logo_media": {
    "alt_text": "Brookstone Apartments logo",
    "public_id": "019d63af-1d4a-77ea-ac33-9d75191b3b30",
    "storage_key": "property/6767906449167348/019d63af-1d4a-77ea-ac33-9d75191b3b30.webp",
    "width": 600,
    "height": 63
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63af-78c3-7102-94cd-4af38e20ed19.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d63af-78c3-7102-94cd-4af38e20ed19",
    "storage_key": "property/6767906449167348/019d63af-78c3-7102-94cd-4af38e20ed19.webp",
    "width": 600,
    "height": 63
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63af-6156-732f-8ab1-c330c0059998.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d63af-6156-732f-8ab1-c330c0059998",
    "storage_key": "property/6767906449167348/019d63af-6156-732f-8ab1-c330c0059998.webp",
    "width": 600,
    "height": 63
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
  "property_company_logo_media": {
    "alt_text": "Dietz Property Group logo",
    "public_id": "019d638a-0da7-727f-ad43-3bd78629f61b",
    "storage_key": "company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
    "width": 992,
    "height": 329
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "DPG logo",
    "public_id": "019e28a2-379b-72ca-a5a9-1262d569a77e",
    "storage_key": "company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
    "width": 344,
    "height": 329
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "DPG logo in white on black background.",
    "public_id": "019e28a2-7e6e-752b-a7e2-54f21a5cd171",
    "storage_key": "company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
    "width": 344,
    "height": 329
  },
  "property_primary_color": "#960118",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "851 - 1001",
  "property_sqft_min": "851",
  "property_sqft_max": "1001",
  "property_price_range": "939 - 1199",
  "property_price_min": "939",
  "property_price_max": "1199",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/groups/1765501813752272/posts/3261384154164023/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ3WUIn44vP4gRVoHmMOrtbM4",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/brookstone-bellefontaine",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Brookstone Apartments",
  "property_home_romance_title": "Embrace Comfort and Connection at Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Brookstone Apartments in Bellefontaine, OH, where comfort meets convenience. Choose from our spacious two and three-bedroom floor plans, each designed for modern living. Enjoy a pet-friendly community with on-site management, laundry facilities, and a playground. Take a step into your new home today and embrace a vibrant lifestyle!",
  "property_home_floorplans_blurb": "At Brookstone Apartments in Bellefontaine, OH, find the ideal setting for your life with spacious two and three-bedroom floor plans. Each home is designed for comfort and style, inviting you to create memories that last. Browse our available apartments today and uncover the perfect floor plan tailored to your lifestyle.",
  "property_home_gallery_blurb": "At Brookstone Apartments in Bellefontaine, OH, two- and three-bedroom floor plans invite you to embrace a lifestyle of comfort and convenience. With pet-friendly amenities, professional management, and a playground just steps away, imagine relaxing on your private balcony while enjoying high-speed internet access. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At Brookstone Apartments in Bellefontaine, OH, life is vibrant and convenient. Embrace the charm of nearby attractions like Piatt Castle Mac-A-Cheek and the historic Court Avenue, the oldest concrete street in America. With engaging parks and community hotspots like the YMCA, your ideal lifestyle awaits right outside your door.",
  "property_home_reviews_blurb": "At Brookstone Apartments in Bellefontaine, OH, residents celebrate their community with glowing praise: “The staff truly cares about our comfort and happiness!” Join a vibrant neighborhood where kindness meets convenience. Unlock the thriving lifestyle our residents cherish—read their heartfelt experiences today!",
  "property_neighborhood_blurb": "At Brookstone Apartments in Bellefontaine, you’re not just getting a home; you’re stepping into a vibrant community. Uncover local gems like the historic Piatt Castle Mac-A-Cheek, the charming Logan County History Center, and the serene Southview Park. Dive into nearby attractions and enjoy the best of local life!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Brookstone Apartments in Bellefontaine, OH, experience a blend of comfort and convenience. Enjoy spacious two and three-bedroom floor plans, pet-friendly policies, and top-notch amenities like a playground, controlled access, and high-speed internet. Visit us today to see why our community is the ideal place to call home!",
  "property_applynow_blurb": "Welcome to Brookstone Apartments in Bellefontaine, OH, where comfort meets convenience! Choose from spacious two and three-bedroom floor plans, complete with modern amenities like a balcony, high-speed internet, and controlled access. Pet-friendly and equipped with on-site management, your ideal living space awaits. Lease online today and find your new home!",
  "property_contactus_blurb": "At Brookstone Apartments in Bellefontaine, OH, spacious two and three-bedroom floor plans await you. Perfectly designed for modern living, our homes offer comfort and style. Curious about availability or need assistance? Don’t hesitate to reach out—our friendly leasing team is here to help you find your perfect fit!",
  "property_faqs_blurb": "At Brookstone Apartments in Bellefontaine, OH, our thoughtfully designed two and three-bedroom floor plans cater to your every need. With spacious layouts and modern amenities, your ideal home awaits. Have questions? Visit our FAQs page for the answers you seek about our vibrant community and all it has to offer.",
  "property_floorplans_blurb": "At Brookstone Apartments in Bellefontaine, OH, spacious living awaits you! Choose from our thoughtfully designed two-bedroom and three-bedroom floor plans, perfect for every lifestyle. Embrace comfort and style in a community that feels like home. Browse our available apartment homes and find your perfect floor plan today!",
  "property_gallery_blurb": "At Brookstone Apartments in Bellefontaine, OH, your dream home awaits! Choose from spacious two or three-bedroom floor plans featuring modern amenities like pet-friendly balconies, high-speed internet, and convenient laundry facilities. Picture yourself enjoying a community playground and relaxing in a professionally managed environment. Your ideal lifestyle starts here!",
  "property_interactivemap_blurb": "Welcome to Brookstone Apartments in Bellefontaine, OH, where comfort meets convenience. Choose from spacious two- and three-bedroom layouts, complete with modern amenities like high-speed internet, a cozy balcony, and a pet-friendly atmosphere. Visit our interactive community map to find your perfect home today!",
  "property_pets_blurb": "Step into comfort at Brookstone Apartments in Bellefontaine, OH, where furry friends are part of the family! With a welcoming pet policy for cats and dogs, you can enjoy spacious living alongside your beloved companions. Experience a vibrant community where modern living meets nature’s beauty.",
  "property_referafriend_blurb": "At Brookstone Apartments in Bellefontaine, OH, our spacious two- and three-bedroom floor plans are perfect for cultivating friendships. Enjoy a vibrant community where great friends become great neighbors. Share the experience—refer a friend today and help them find their new home in our exceptional community!",
  "property_residentaccess_blurb": "Welcome to Brookstone Apartments in charming Bellefontaine, OH, where spacious two and three-bedroom floor plans await your discovery. Enjoy the convenience of our resident portal—your one-stop solution to pay rent, schedule maintenance, and elevate your living experience. Dive into worry-free living today!",
  "property_reviews_blurb": "At Brookstone Apartments in Bellefontaine, OH, residents rave, “The community feels like home, with friendly neighbors and beautiful landscapes.” Experience the charm and comfort that define our vibrant community. Check out our reviews and see what makes Brookstone the perfect place to create lasting memories!",
  "property_created_at": "1775493836662",
  "property_scheduletour_blurb": "At Brookstone Apartments in beautiful Bellefontaine, OH, choose from spacious two and three-bedroom floor plans that fit your lifestyle perfectly. Experience community living like never before, and hear firsthand from our residents about their vibrant experiences. Schedule a tour today and envision your future in a place you can truly call home!",
  "property_thankyou_blurb": "Thank you for reaching out to Brookstone Apartments in beautiful Bellefontaine, OH! We offer spacious two and three-bedroom floor plans tailored for comfort and style. A team member will be in touch soon to assist you in finding your perfect home. Your journey to exceptional living begins here!",
  "property_virtualtours_blurb": "At Brookstone Apartments in Bellefontaine, OH, find your perfect home with spacious two-bedroom and three-bedroom layouts tailored for modern living. Immerse yourself in our vibrant community from the comfort of your own screen—take a virtual tour today and envision your new life in this inviting setting!",
  "property_copyright": "2026 All Rights Reserved. Brookstone Apartments",
  "property_seo_title_home": "Affordable Apartments Bellefontaine, OH | Brookstone",
  "property_seo_description_home": "Explore affordable two- and three-bedroom apartments in Bellefontaine, OH at Brookstone. Income restrictions apply. View floor plans and availability.",
  "property_seo_title_floorplans": "Affordable 2 & 3 Bed Apts in Bellefontaine, OH | Floor Plans",
  "property_seo_description_floorplans": "View affordable 2- and 3-bedroom apartments in Bellefontaine, OH, at Brookstone. Each apartment offers comfort and convenience designed for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Bellefontaine, OH Apartments for Rent",
  "property_seo_description_amenities": "Experience the charm of Brookstone Apartments in Bellefontaine, OH. Enjoy spacious two and three-bedroom layouts, pet-friendly living, and top-notch amenities!",
  "property_seo_title_gallery": "Gallery | Apartments in Bellefontaine, OH",
  "property_seo_description_gallery": "Discover your ideal life at Brookstone Apartments, Bellefontaine, OH! Enjoy spacious two and three-bedroom homes with excellent amenities.",
  "property_seo_title_virtualtours": "Virtual Tours | Brookstone Apartments Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Brookstone Apartments in Bellefontaine, OH. Take a virtual tour today and find your ideal two or three-bedroom home!",
  "property_seo_title_interactivemap": "Interactive Map | Brookstone Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Brookstone Apartments, Bellefontaine, OH! Explore two- and three-bedroom options with exceptional amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Bellefontaine, OH",
  "property_seo_description_neighborhood": "Experience Bellefontaine living at Brookstone Apartments! Uncover local favorites and attractions just steps away from your new two or three-bedroom home.",
  "property_seo_title_contact": "Contact Us | Brookstone Apartments",
  "property_seo_description_contact": "Connect with Brookstone Apartments in Bellefontaine, OH! Inquire about our spacious two and three-bedroom floor plans. Your next home awaits—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Bellefontaine, OH",
  "property_seo_description_faqs": "Discover Brookstone Apartments in Bellefontaine, OH! Enjoy our pet-friendly community, modern amenities, and answers to your FAQs today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Bellefontaine, OH",
  "property_seo_description_reviews": "Experience the charm of Brookstone Apartments in Bellefontaine, OH. Read resident reviews and see why our community feels like home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Bellefontaine, OH",
  "property_seo_description_applynow": "Elevate your lifestyle at Brookstone Apartments in Bellefontaine, OH. Two- and three-bedroom homes with modern amenities await. Apply and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Brookstone Apartments",
  "property_seo_description_residentaccess": "Unlock convenience at Brookstone Apartments! Log in to manage rent, request maintenance, and connect with your community. All your needs, just a click away!",
  "property_seo_title_referafriend": "Refer A Friend | Brookstone Apartments",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Brookstone Apartments in Bellefontaine, OH, and enjoy a vibrant community atmosphere together.",
  "property_seo_title_scheduletour": "Schedule a Tour | Brookstone Apartments",
  "property_seo_description_scheduletour": "Discover the charm of Brookstone Apartments in Bellefontaine, OH. Schedule your tour today and explore your future home!",
  "property_seo_title_privacy": "Privacy Policy | Brookstone Apartments",
  "property_seo_description_privacy": "Your privacy matters at Brookstone Apartments in Bellefontaine, OH. Dive into our commitment to your security and comfort—read our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Brookstone Apartments",
  "property_seo_description_accessibility": "At Brookstone Apartments in Bellefontaine, OH, we prioritize accessibility for all. Experience inclusive living designed for your comfort and convenience.",
  "property_seo_title_sitemap": "Sitemap | Brookstone Apartments",
  "property_seo_description_sitemap": "Navigate Brookstone Apartments in Bellefontaine, OH with ease! Check out our sitemap for a seamless journey through your future home. Your new life awaits!",
  "property_seo_title_thankyou": "Thank You | Brookstone Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to vibrant living at Brookstone Apartments in Bellefontaine begins here—stay tuned for a team member’s warm welcome!",
  "property_seo_title_pets": "Pet Policy | Apartments in Bellefontaine, OH",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790199188643",
  "amenities": [
    {
      "id": "ec_4224af2ac53ce27cd019fd55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "realpage",
      "external_id": "P000000617",
      "title": "Professional Management",
      "amount": "0.0000",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16e70decef10c44f8f7bf387",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "realpage",
      "external_id": "P000000619",
      "title": "Ideal Location",
      "amount": "0.0000",
      "description": "Nearby Shopping and Entertainment",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82079bba75e75ed3d09058fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "realpage",
      "external_id": "P000000702",
      "title": "Flexible Rent Payments",
      "amount": "0.0000",
      "description": "Flexible Rent Payments",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f538f72a5673139b843accb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "realpage",
      "external_id": "P000000716",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Dog Park",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8acc89239a099f809db85f0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "realpage",
      "external_id": "P000000717",
      "title": "Laundry Facility",
      "amount": "0.0000",
      "description": "Laundry Facility",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a326559e552b04e391d3e4d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "realpage",
      "external_id": "P000000721",
      "title": "Controlled Access",
      "amount": "0.0000",
      "description": "Controlled Access",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f852b29c2dc8036d549eb65a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "realpage",
      "external_id": "P000000727",
      "title": "Playground",
      "amount": "0.0000",
      "description": "Playground",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2174a67d3446caf02a62db85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "realpage",
      "external_id": "P000000663",
      "title": "Patio / Balcony",
      "amount": "0.0000",
      "description": "Balcony / Patio",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25d26d70765fcd8d9796e314",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "realpage",
      "external_id": "P000000670",
      "title": "Ceiling Fan",
      "amount": "3.0000",
      "description": "Ceiling Fan",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_796f88d86661f5c0ba4e267e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "realpage",
      "external_id": "P000000683",
      "title": "Kitchen Disposal",
      "amount": "0.0000",
      "description": "Garbage disposal",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3f98a6eb64ee155a6a478f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "realpage",
      "external_id": "P000000685",
      "title": "Microwave",
      "amount": "0.0000",
      "description": "Under cabinet or countertop microwave",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c99fad2668d08598ec611317",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "realpage",
      "external_id": "P000000692",
      "title": "High Speed Internet",
      "amount": "0.0000",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01cd91e86ec9780b6819eb50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "realpage",
      "external_id": "P000000693",
      "title": "Central Heat & Air",
      "amount": "0.0000",
      "description": "Central Heat & Air Conditionin",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea929429a23c366c39d6597e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "realpage",
      "external_id": "S100000159",
      "title": "Refrigerator",
      "amount": "15.0000",
      "description": "Side-by-side refrigerator with no ice dispenser",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30697551969a4eed69870574",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "realpage",
      "external_id": "S100000264",
      "title": "Dishwasher",
      "amount": "0.0000",
      "description": "Dishwasher",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_134110b86a4a832e8fcd7ce1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "realpage",
      "external_id": "S100000268",
      "title": "Black appliances",
      "amount": "0.0000",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_f7d99bc6-f7c4-4075-84f2-6a56240ea6a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-e6a6-755a-be16-b0e525401957.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment unit, showing a pass-through to the kitchen and a living area with a ceiling fan at Brookstone Apartments in Bellefontaine.",
        "public_id": "019d63b1-e6a6-755a-be16-b0e525401957",
        "storage_key": "property/6767906449167348/019d63b1-e6a6-755a-be16-b0e525401957.webp",
        "width": 1536,
        "height": 864
      },
      "title": "Apartment",
      "description": "Spacious apartment interior featuring a pass-through to the kitchen and a well-lit living area. Ideal for comfortable living.",
      "link": "",
      "alt_text": "Interior view of an apartment unit, showing a pass-through to the kitchen and a living area with a ceiling fan at Brookstone Apartments in Bellefontaine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9910b17e-d79b-4ed9-8751-583aae33d61d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-d364-757c-8e40-0387dfe71b77.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and vanity at Brookstone Apartments in Bellefontaine.",
        "public_id": "019d63b1-d364-757c-8e40-0387dfe71b77",
        "storage_key": "property/6767906449167348/019d63b1-d364-757c-8e40-0387dfe71b77.webp",
        "width": 1536,
        "height": 864
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large closet and a private vanity area with a sink and mirror.",
      "link": "",
      "alt_text": "Bedroom with closet and vanity at Brookstone Apartments in Bellefontaine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7bc4daf3-89c1-4873-a604-4debade69c44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-cb94-771a-9b60-4a3122125057.webp",
      "image_media": {
        "alt_text": "Playground with slide, climbing structure, and bench at Brookstone Apartments in Bellefontaine.",
        "public_id": "019d63b1-cb94-771a-9b60-4a3122125057",
        "storage_key": "property/6767906449167348/019d63b1-cb94-771a-9b60-4a3122125057.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring a slide, climbing area, and seating for parents.",
      "link": "",
      "alt_text": "Playground with slide, climbing structure, and bench at Brookstone Apartments in Bellefontaine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a280a3cf-aa60-4600-9741-fa31a25a6d64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-cf13-75fe-a1ec-70b12367a32a.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, white refrigerator, and white electric stove with black cooktop at Brookstone Apartments in Bellefontaine.",
        "public_id": "019d63b1-cf13-75fe-a1ec-70b12367a32a",
        "storage_key": "property/6767906449167348/019d63b1-cf13-75fe-a1ec-70b12367a32a.webp",
        "width": 1536,
        "height": 864
      },
      "title": "Apartment",
      "description": "Compact kitchen space featuring white cabinetry, a refrigerator, and a white electric stove. Includes a glimpse of a utility closet.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, white refrigerator, and white electric stove with black cooktop at Brookstone Apartments in Bellefontaine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1aa66dff-6439-45f6-852a-67fbfbe50ce5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-cdda-7058-b1be-608c74997e1d.webp",
      "image_media": {
        "alt_text": "Kitchen with a sink, countertop, and cabinets. A pass-through window overlooks another room at Brookstone Apartments in Bellefontaine.",
        "public_id": "019d63b1-cdda-7058-b1be-608c74997e1d",
        "storage_key": "property/6767906449167348/019d63b1-cdda-7058-b1be-608c74997e1d.webp",
        "width": 1536,
        "height": 864
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring a double-basin sink, ample countertop space, and clean white cabinetry. A convenient pass-through window connects the kitchen to the adjacent living area.",
      "link": "",
      "alt_text": "Kitchen with a sink, countertop, and cabinets. A pass-through window overlooks another room at Brookstone Apartments in Bellefontaine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e5e4a3bc-cb89-4e2b-92de-ab06790c882a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-b28c-707c-8d07-2478af8731eb.webp",
      "image_media": {
        "alt_text": "Exterior of a brick and siding apartment building with balconies and a parking lot at Brookstone Apartments in Bellefontaine.",
        "public_id": "019d63b1-b28c-707c-8d07-2478af8731eb",
        "storage_key": "property/6767906449167348/019d63b1-b28c-707c-8d07-2478af8731eb.webp",
        "width": 1536,
        "height": 987
      },
      "title": "Community",
      "description": "View of the exterior of the apartment building, showcasing its brick and siding facade, private balconies, and well-maintained grounds. Includes a parking lot and green spaces.",
      "link": "",
      "alt_text": "Exterior of a brick and siding apartment building with balconies and a parking lot at Brookstone Apartments in Bellefontaine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ad29bbbb-4cac-42b7-bf20-12b3942a3670",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-b7a7-7668-9d4e-5e6b47b42a7c.webp",
      "image_media": {
        "alt_text": "Bright bedroom with a queen-sized bed, green and grey bedding, decorative pillows, and a full-length mirror at Brookstone Apartments in Bellefontaine.",
        "public_id": "019d63b1-b7a7-7668-9d4e-5e6b47b42a7c",
        "storage_key": "property/6767906449167348/019d63b1-b7a7-7668-9d4e-5e6b47b42a7c.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a cozy queen-sized bed and elegant decor.",
      "link": "",
      "alt_text": "Bright bedroom with a queen-sized bed, green and grey bedding, decorative pillows, and a full-length mirror at Brookstone Apartments in Bellefontaine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_286be4fb-f156-4001-b5aa-30b74f34fc36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-b094-71eb-b5f4-455fa12a11e7.webp",
      "image_media": {
        "alt_text": "Brookstone Apartments monument sign with phone number and website at Brookstone Apartments in Bellefontaine.",
        "public_id": "019d63b1-b094-71eb-b5f4-455fa12a11e7",
        "storage_key": "property/6767906449167348/019d63b1-b094-71eb-b5f4-455fa12a11e7.webp",
        "width": 1536,
        "height": 916
      },
      "title": "Community",
      "description": "Welcome to Brookstone Apartments, where comfort and convenience meet. Call us at 937.592.9393 or visit YourNextPlaceToLive.com.",
      "link": "",
      "alt_text": "Brookstone Apartments monument sign with phone number and website at Brookstone Apartments in Bellefontaine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_25410152-b19b-40d3-9430-8ce0068762da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-b1c5-704a-81ea-9f2c338044e7.webp",
      "image_media": {
        "alt_text": "Exterior of a multi-story apartment building with balconies and a green lawn at Brookstone Apartments in Bellefontaine.",
        "public_id": "019d63b1-b1c5-704a-81ea-9f2c338044e7",
        "storage_key": "property/6767906449167348/019d63b1-b1c5-704a-81ea-9f2c338044e7.webp",
        "width": 1536,
        "height": 984
      },
      "title": "Community",
      "description": "A view of the exterior of the apartment building, featuring multiple levels with balconies, set against a backdrop of green grass and trees under a partly cloudy sky.",
      "link": "",
      "alt_text": "Exterior of a multi-story apartment building with balconies and a green lawn at Brookstone Apartments in Bellefontaine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0df85e1c-8b38-4d92-aa06-f0dcfde76b73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-afd2-75bd-a25b-f2c06eaf5fe7.webp",
      "image_media": {
        "alt_text": "Cozy living room corner with a mug of coffee and a plant on a side table at Brookstone Apartments in Bellefontaine.",
        "public_id": "019d63b1-afd2-75bd-a25b-f2c06eaf5fe7",
        "storage_key": "property/6767906449167348/019d63b1-afd2-75bd-a25b-f2c06eaf5fe7.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax and unwind in your beautifully appointed living space, featuring comfortable seating and tasteful decor.",
      "link": "",
      "alt_text": "Cozy living room corner with a mug of coffee and a plant on a side table at Brookstone Apartments in Bellefontaine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_7c2d681b-be2f-4890-84e8-0451f6d98945",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Six Hundred Downtown",
      "poi_type": "Restaurants",
      "poi_address": "108 S Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Popular pizzeria serving Detroit-style and signature pies, along with cocktails and beer menus.",
      "poi_long_description": "People say this pizza restaurant serves delicious pizza, garlic knots, and pepperoni rolls. They highlight the fresh ingredients, generous portions, and the option to choose from various pizza styles, including Detroit and Sicilian. They also like the fun, lively atmosphere and the attentive, friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63ae-e772-7082-8c34-778d2da0c10d.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Six Hundred Downtown restaurant with open sign and pizza neon.",
        "public_id": "019d63ae-e772-7082-8c34-778d2da0c10d",
        "storage_key": "property/6767906449167348/019d63ae-e772-7082-8c34-778d2da0c10d.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.600downtown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=186975073660609850&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "six-hundred-downtown",
      "poi_latitude": "40.360867",
      "poi_longitude": "-83.7601031",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 937-599-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7fcd-735a-b130-09498e2055d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized graphic of a fork and knife",
        "public_id": "019d63b1-7fcd-735a-b130-09498e2055d4",
        "storage_key": "property/6767906449167348/019d63b1-7fcd-735a-b130-09498e2055d4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wl9dWEvP4gROqVkv9ZEmAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_03696774-4482-4027-8ab8-f920b209a4c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Brewfontaine",
      "poi_type": "Restaurants",
      "poi_address": "211 S Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Compact, modern bar offering rotating taps of craft beers & wine, plus sandwiches & salads.",
      "poi_long_description": "Diners say this restaurant offers a great beer selection with several local breweries, and delicious food, like the sirloin cheesesteak and avocado melt. They also highlight the friendly and attentive staff, and fun, lively atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63ae-bcc5-7318-aac0-84d590e4d75c.webp",
      "poi_featured_image_media": {
        "alt_text": "Brewfontaine building exterior at night with illuminated signage.",
        "public_id": "019d63ae-bcc5-7318-aac0-84d590e4d75c",
        "storage_key": "property/6767906449167348/019d63ae-bcc5-7318-aac0-84d590e4d75c.webp",
        "width": 1680,
        "height": 1050
      },
      "poi_business_url": "http://www.brewfontaine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12050927043765432620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brewfontaine",
      "poi_latitude": "40.3593541",
      "poi_longitude": "-83.7597347",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 937-404-9128",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7fcd-735a-b130-09498e2055d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized graphic of a fork and knife",
        "public_id": "019d63b1-7fcd-735a-b130-09498e2055d4",
        "storage_key": "property/6767906449167348/019d63b1-7fcd-735a-b130-09498e2055d4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl_OCLGIvP4gRLHHJOUx-Pac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4bb049e0-8355-4d2c-9284-5537989c2efd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "The Morning Riot",
      "poi_type": "Restaurants",
      "poi_address": "130 S Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this brunch restaurant offers delicious breakfast sandwiches, French toast, and Banh Mi bowls, as well as freshly baked goods like croissants. They highlight the fun atmosphere, retro feel, and the availability of outlets for laptops. They also like the warm, welcoming, and hardworking staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63ae-cc84-716f-bd66-6cf05ddb312d.webp",
      "poi_featured_image_media": {
        "alt_text": "Elegant dining area with modern chandeliers and stylish seating.",
        "public_id": "019d63ae-cc84-716f-bd66-6cf05ddb312d",
        "storage_key": "property/6767906449167348/019d63ae-cc84-716f-bd66-6cf05ddb312d.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://morningriot.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1066541899641350923&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-morning-riot",
      "poi_latitude": "40.3602662",
      "poi_longitude": "-83.76037269999999",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7fcd-735a-b130-09498e2055d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized graphic of a fork and knife",
        "public_id": "019d63b1-7fcd-735a-b130-09498e2055d4",
        "storage_key": "property/6767906449167348/019d63b1-7fcd-735a-b130-09498e2055d4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3wPA97MvP4gRC2sx-jQezQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_30256743-dacf-45cd-b901-239d0ef70f94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Don's Downtown Diner",
      "poi_type": "Restaurants",
      "poi_address": "208 S Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Hamburgers and other American eats in a casual environment with friendly staff.",
      "poi_long_description": "People say this diner serves excellent burgers, thick milkshakes, and fresh salads and vegetables. They highlight the reasonable prices, big portions, and consistently good food. They also like the friendly and fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63ae-d57e-7131-8b71-88d345e5333b.webp",
      "poi_featured_image_media": {
        "alt_text": "Don's Downtown Diner exterior in snow with a white SUV parked outside.",
        "public_id": "019d63ae-d57e-7131-8b71-88d345e5333b",
        "storage_key": "property/6767906449167348/019d63ae-d57e-7131-8b71-88d345e5333b.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://m.facebook.com/Donsdowntowndiner/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9607830579598261736&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dons-downtown-diner",
      "poi_latitude": "40.359419",
      "poi_longitude": "-83.7601304",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 937-599-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7fcd-735a-b130-09498e2055d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized graphic of a fork and knife",
        "public_id": "019d63b1-7fcd-735a-b130-09498e2055d4",
        "storage_key": "property/6767906449167348/019d63b1-7fcd-735a-b130-09498e2055d4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD7yBLmIvP4gR6P0W9wHfVYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_3d14771b-45bc-42cd-bfbd-534319fde424",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "The Flying Pepper Cantina",
      "poi_type": "Restaurants",
      "poi_address": "137 W Columbus Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Casual, family-owned eatery for grilled Mexican dishes, plus margaritas and other cocktails.",
      "poi_long_description": "People say this Mexican restaurant serves delicious, fresh, and authentic Mexican food, including tacos, enchiladas, and street corn. They highlight the reasonable prices, generous portions, and the quaint, relaxed atmosphere. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63ae-ba75-778a-a4ea-c0d2a001bef3.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a restaurant with vibrant wall art and modern lighting fixtures.",
        "public_id": "019d63ae-ba75-778a-a4ea-c0d2a001bef3",
        "storage_key": "property/6767906449167348/019d63ae-ba75-778a-a4ea-c0d2a001bef3.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://www.flyingpeppercantina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2895323579815603816&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-flying-pepper-cantina",
      "poi_latitude": "40.3610649",
      "poi_longitude": "-83.7612304",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 937-210-5042",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7fcd-735a-b130-09498e2055d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized graphic of a fork and knife",
        "public_id": "019d63b1-7fcd-735a-b130-09498e2055d4",
        "storage_key": "property/6767906449167348/019d63b1-7fcd-735a-b130-09498e2055d4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuaaR7GEvP4gRaK64rHRBLig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_62d9a85d-f14b-4624-9101-746025878066",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "2168 US-68, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store has helpful and friendly staff who go out of their way to assist customers. They also highlight the great prices and wide selection of products.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63ae-ba2d-71b9-88d5-a638b4125253.webp",
      "poi_featured_image_media": {
        "alt_text": "Lowe's logo on the building exterior",
        "public_id": "019d63ae-ba2d-71b9-88d5-a638b4125253",
        "storage_key": "property/6767906449167348/019d63ae-ba2d-71b9-88d5-a638b4125253.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OH-Bellefontaine/0009?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-9-_-na-_-0-_-0&y_source=1_MTE4NDQ2MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12148879597111174648&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "40.330126",
      "poi_longitude": "-83.76364199999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 937-599-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f75-75b5-bc80-48555241210c.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smiling face",
        "public_id": "019d63b1-7f75-75b5-bc80-48555241210c",
        "storage_key": "property/6767906449167348/019d63b1-7f75-75b5-bc80-48555241210c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQxsZOogvP4gR-GXNRKB9mag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_4d8d5677-8b4d-44c2-8fd5-3d2fea2ceea3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "2129 S Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63ae-ba69-7023-bf8c-2253ebb34918.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Kroger supermarket with a pharmacy entrance.",
        "public_id": "019d63ae-ba69-7023-bf8c-2253ebb34918",
        "storage_key": "property/6767906449167348/019d63ae-ba69-7023-bf8c-2253ebb34918.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/oh/bellefontaine/bellefontaine/016/00832?cid=loc_01600832_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3342860515876212390&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "40.3309428",
      "poi_longitude": "-83.760404",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 937-599-1208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f82-760d-8a04-0256a16a8de3.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d63b1-7f82-760d-8a04-0256a16a8de3",
        "storage_key": "property/6767906449167348/019d63b1-7f82-760d-8a04-0256a16a8de3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDUnFD4gvP4gRpg57ju05ZC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_41e2305c-e8c2-4a34-8a37-c8f661c384a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Wengers Produce",
      "poi_type": "Shopping & Retail",
      "poi_address": "3836 County Rd 29, West Liberty, OH 43357, USA",
      "poi_short_description": "Retail outfit for locally grown fruits and vegetables, plus baked goods, cheeses and meats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63ae-c89e-74d9-bb0b-e98d40a1b0b3.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a red barn building with an open door, a child walking inside, plants and decorations outside.",
        "public_id": "019d63ae-c89e-74d9-bb0b-e98d40a1b0b3",
        "storage_key": "property/6767906449167348/019d63ae-c89e-74d9-bb0b-e98d40a1b0b3.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://www.facebook.com/people/Wengers-Produce/100057126413919/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3310470150169562937&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wengers-produce",
      "poi_latitude": "40.3037242",
      "poi_longitude": "-83.70159509999999",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 937-592-5726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f82-760d-8a04-0256a16a8de3.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d63b1-7f82-760d-8a04-0256a16a8de3",
        "storage_key": "property/6767906449167348/019d63b1-7f82-760d-8a04-0256a16a8de3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUQ7wBiEuP4gROQ9k3A8n8S0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_bde0ad4f-7e82-4732-8843-718380a8d275",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "2175 US-68, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d7918-7f10-7045-b7e0-2281032bda46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-7f10-7045-b7e0-2281032bda46",
        "storage_key": "property/6767906449167348/019d7918-7f10-7045-b7e0-2281032bda46.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/oh/bellefontaine/2175-us-highway-68-s/f512",
      "poi_directions_map_url": "https://maps.google.com/?cid=13433590194047931504&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "40.33007",
      "poi_longitude": "-83.76062",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f82-760d-8a04-0256a16a8de3.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d63b1-7f82-760d-8a04-0256a16a8de3",
        "storage_key": "property/6767906449167348/019d63b1-7f82-760d-8a04-0256a16a8de3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNYTXkYkvP4gRcNRldhuzbbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_0edc670b-acf3-443b-bd4d-37220146cf4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Thoman's IGA",
      "poi_type": "Shopping & Retail",
      "poi_address": "201 S Detroit St, West Liberty, OH 43357, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this grocery store offers a great selection of local goods, name brands, and staples, as well as a deli and bakery. They highlight the good prices, clean and organized store, and friendly staff. They also like the small carts for children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d7918-8100-74bd-8b90-e1454bbd9c95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-8100-74bd-8b90-e1454bbd9c95",
        "storage_key": "property/6767906449167348/019d7918-8100-74bd-8b90-e1454bbd9c95.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thomans.iga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15720508528076037416&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thomans-iga",
      "poi_latitude": "40.2508705",
      "poi_longitude": "-83.7549646",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 937-465-3936",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f82-760d-8a04-0256a16a8de3.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d63b1-7f82-760d-8a04-0256a16a8de3",
        "storage_key": "property/6767906449167348/019d63b1-7f82-760d-8a04-0256a16a8de3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK0iocpswP4gRKJ14KDd3Kto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_931aedcd-6a4c-49bd-b3f6-85df0929969e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Logan County Libraries",
      "poi_type": "Education",
      "poi_address": "220 N Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Public library with a children's section offering a range of board books and toys.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d7918-8655-75b8-bd87-b419780a9b0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-8655-75b8-bd87-b419780a9b0c",
        "storage_key": "property/6767906449167348/019d7918-8655-75b8-bd87-b419780a9b0c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://logancountylibraries.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16932861840026475643&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "logan-county-libraries",
      "poi_latitude": "40.363738",
      "poi_longitude": "-83.7590603",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 937-599-4189",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f7a-77b6-a95a-3956657e15fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d63b1-7f7a-77b6-a95a-3956657e15fc",
        "storage_key": "property/6767906449167348/019d63b1-7f7a-77b6-a95a-3956657e15fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ91ch92AvP4gRe5yLHSGc_eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_b6cd7953-9b86-4632-95d7-8cab6763732f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Piatt Castle Mac-A-Cheek",
      "poi_type": "Entertainment",
      "poi_address": "10051 Township Rd 47, West Liberty, OH 43357, USA",
      "poi_short_description": "Estate with 2 castle-style historic homes, featuring artifacts & exhibits on Ohio history.",
      "poi_long_description": "Estate with 2 castle-style historic homes, featuring artifacts & exhibits on Ohio history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d7918-8377-77a8-9394-32930ff1bb75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-8377-77a8-9394-32930ff1bb75",
        "storage_key": "property/6767906449167348/019d7918-8377-77a8-9394-32930ff1bb75.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://piattcastle.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6393053394559602793&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "piatt-castle-mac-a-cheek",
      "poi_latitude": "40.25105430000001",
      "poi_longitude": "-83.72679049999999",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 937-465-2821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f7e-76f3-9a20-96243e6d5a64.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with letter M inside.",
        "public_id": "019d63b1-7f7e-76f3-9a20-96243e6d5a64",
        "storage_key": "property/6767906449167348/019d63b1-7f7e-76f3-9a20-96243e6d5a64.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5dd79-8wP4gRaZDUxDCwuFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_fbfcfd00-d89d-4115-80ef-55a9ad5a72cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Logan County History Center",
      "poi_type": "Entertainment",
      "poi_address": "521 E Columbus Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Museum of local history that consists of a mansion, exhibits and research room.",
      "poi_long_description": "Visitors say this history museum features a variety of historical pieces, including exhibits on rail history, Shriner history, and the town itself. They also highlight the helpful and informative staff who provide tours of the museum and its mansion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63ae-f37f-736f-99c6-bd054508d6a9.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a building with a parking lot in the foreground.",
        "public_id": "019d63ae-f37f-736f-99c6-bd054508d6a9",
        "storage_key": "property/6767906449167348/019d63ae-f37f-736f-99c6-bd054508d6a9.webp",
        "width": 1275,
        "height": 1650
      },
      "poi_business_url": "http://loganhistory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2168627646289126221&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "logan-county-history-center",
      "poi_latitude": "40.361351",
      "poi_longitude": "-83.7507705",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 937-593-7557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f7e-76f3-9a20-96243e6d5a64.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with letter M inside.",
        "public_id": "019d63b1-7f7e-76f3-9a20-96243e6d5a64",
        "storage_key": "property/6767906449167348/019d63b1-7f7e-76f3-9a20-96243e6d5a64.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQe45vmgvP4gRTaMnu1qDGB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_f007fef8-3fb4-440b-87b8-c368ad0da8b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "AccuSport Stadium",
      "poi_type": "Entertainment",
      "poi_address": "555 E Lake Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d7918-8e0f-705a-ab4a-72423465fd81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-8e0f-705a-ab4a-72423465fd81",
        "storage_key": "property/6767906449167348/019d7918-8e0f-705a-ab4a-72423465fd81.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ohiostadiums.com/stadium.php?id=1952",
      "poi_directions_map_url": "https://maps.google.com/?cid=75909093468098867&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "accusport-stadium",
      "poi_latitude": "40.3490534",
      "poi_longitude": "-83.75279259999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7fd4-77d9-b3e9-58b513737c73.webp",
      "poi_map_icon_media": {
        "alt_text": "Property Management Company Logo",
        "public_id": "019d63b1-7fd4-77d9-b3e9-58b513737c73",
        "storage_key": "property/6767906449167348/019d63b1-7fd4-77d9-b3e9-58b513737c73.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEUT1SF8vP4gRM1FjF-uuDQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_9f2e885d-5734-4a2a-bfbe-74a640576aa8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Court Avenue - Oldest Concrete Street In America",
      "poi_type": "Entertainment",
      "poi_address": "101-163 E Court Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63af-397b-74b7-a55a-f5154179f29e.webp",
      "poi_featured_image_media": {
        "alt_text": "Archway over Court Avenue, recognizing it as the oldest concrete street in America.",
        "public_id": "019d63af-397b-74b7-a55a-f5154179f29e",
        "storage_key": "property/6767906449167348/019d63af-397b-74b7-a55a-f5154179f29e.webp",
        "width": 3024,
        "height": 2318
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6480238682727759064&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "court-avenue---oldest-concrete-street-in-america",
      "poi_latitude": "40.3604128",
      "poi_longitude": "-83.7596183",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b1-7f8c-7075-a73b-64f9f69e38b8",
        "storage_key": "property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL80TeGEvP4gR2Ly7h79u7lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_f2c6e3eb-d432-4ab4-841b-a3097030bcf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Don M. And Margaret Hilliker YMCA - YMCA of Central Ohio",
      "poi_type": "Health and Wellness",
      "poi_address": "300 Sloan Blvd, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "People say this gym offers a variety of exercise equipment, including weight machines, and has a track and basketball court. They also highlight the friendly and helpful staff, and the fun water exercises and group classes.\n\nOther reviews mention the equipment can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63af-35e5-73ab-bbf0-1c2e74949c7b.webp",
      "poi_featured_image_media": {
        "alt_text": "Building entrance with covered walkway, brick pillars, and landscaping.",
        "public_id": "019d63af-35e5-73ab-bbf0-1c2e74949c7b",
        "storage_key": "property/6767906449167348/019d63af-35e5-73ab-bbf0-1c2e74949c7b.webp",
        "width": 1400,
        "height": 651
      },
      "poi_business_url": "https://ymcacolumbus.org/locations/hilliker?utm_source=google_business_profile&utm_medium=Organic&utm_campaign=gbp_hilliker",
      "poi_directions_map_url": "https://maps.google.com/?cid=2480290566107687829&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "don-m-and-margaret-hilliker-ymca---ymca-of-central-ohio",
      "poi_latitude": "40.36471179999999",
      "poi_longitude": "-83.717186",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 614-389-4364",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b1-7f8c-7075-a73b-64f9f69e38b8",
        "storage_key": "property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn1wFuiAvP4gRleuZ9CDDayI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6fc1317e-eb88-4af5-b6fa-04a08ce3fbcf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "North Side Animal Clinic Inc",
      "poi_type": "Health and Wellness",
      "poi_address": "1770 US-68, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63af-386d-75aa-80da-4ac7e70084c4.webp",
      "poi_featured_image_media": {
        "alt_text": "A black dog with pointed ears and a purple leash lies on a textured floor.",
        "public_id": "019d63af-386d-75aa-80da-4ac7e70084c4",
        "storage_key": "property/6767906449167348/019d63af-386d-75aa-80da-4ac7e70084c4.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.northsideanimalclinicinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13039789352799597602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-side-animal-clinic-inc",
      "poi_latitude": "40.3874555",
      "poi_longitude": "-83.75197179999999",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 937-593-6951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b1-7f8c-7075-a73b-64f9f69e38b8",
        "storage_key": "property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhbkjUYcvP4gRInSKH1Sj9rQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_1db8ae5d-63ec-41de-87cc-b889f3723985",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Southgate Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "3142 US-68, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63af-76d7-74df-83fc-942cdde6f5ff.webp",
      "poi_featured_image_media": {
        "alt_text": "English Bulldog wearing a pink vest on a leash",
        "public_id": "019d63af-76d7-74df-83fc-942cdde6f5ff",
        "storage_key": "property/6767906449167348/019d63af-76d7-74df-83fc-942cdde6f5ff.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.southgatevet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9972309426614833579&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southgate-veterinary-clinic",
      "poi_latitude": "40.3163104",
      "poi_longitude": "-83.7608498",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 937-592-9816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b1-7f8c-7075-a73b-64f9f69e38b8",
        "storage_key": "property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Uoh1vgvP4gRqxGog5bCZIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_66ee8628-831c-4d85-86f2-4b5ce4463d0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "210 W Columbus Ave Suite 1, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Chain fitness center with 24/7 access, a variety of equipment, personal training, and group workouts.",
      "poi_long_description": "People say this gym offers a variety of equipment, including free weights, machines, and cardio gear, and provides access to supplements and meals. They highlight the clean facilities, well-maintained equipment, and convenient 24/7 access. They also like the friendly, knowledgeable, and supportive staff, and the welcoming and encouraging community vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d7918-9662-707d-be49-603f3a96b093.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-9662-707d-be49-603f3a96b093",
        "storage_key": "property/6767906449167348/019d7918-9662-707d-be49-603f3a96b093.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/bellefontaine-ohio-2478/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=2478",
      "poi_directions_map_url": "https://maps.google.com/?cid=18180523005994453642&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "40.361509",
      "poi_longitude": "-83.7621942",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 937-595-0303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b1-7f8c-7075-a73b-64f9f69e38b8",
        "storage_key": "property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzWKgD4kvP4gRisodc1kxTvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0cbc979c-a024-409f-a5b8-d0ea69a634cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Q Nail Lounge +",
      "poi_type": "Health and Wellness",
      "poi_address": "2305 S Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Nail salon offering services such as pedicures in a clean and welcoming environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63af-9be3-70df-9e8d-4bc763a74aae.webp",
      "poi_featured_image_media": {
        "alt_text": "Q Nail Lounge+ logo and beautifully designed long pink and white stiletto nails with gold studs and flower accents.",
        "public_id": "019d63af-9be3-70df-9e8d-4bc763a74aae",
        "storage_key": "property/6767906449167348/019d63af-9be3-70df-9e8d-4bc763a74aae.webp",
        "width": 1536,
        "height": 2048
      },
      "poi_business_url": "https://qnailloungeplus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9659369617240203771&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "q-nail-lounge-",
      "poi_latitude": "40.3276863",
      "poi_longitude": "-83.7605667",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 937-594-1367",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b1-7f8c-7075-a73b-64f9f69e38b8",
        "storage_key": "property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCdI-BBwvP4gR-6HNRX35DIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_a3374fc1-8699-495b-a128-f849b237fa61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "2232 S Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63af-6e95-75f3-a3bb-420216a92876.webp",
      "poi_featured_image_media": {
        "alt_text": "Screenshot of the Great Clips app showing online check-in functionality on two iPhones.",
        "public_id": "019d63af-6e95-75f3-a3bb-420216a92876",
        "storage_key": "property/6767906449167348/019d63af-6e95-75f3-a3bb-420216a92876.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/oh/bellefontaine/2232-s-main-st?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16063543327234501745&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "40.32905960000001",
      "poi_longitude": "-83.76192209999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 937-599-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b1-7f8c-7075-a73b-64f9f69e38b8",
        "storage_key": "property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm7As8okvP4gRcazoPYwr7d4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_7c6a0780-6691-40c9-8dca-7e5aade970e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Relax Nail Bar + Salon",
      "poi_type": "Health and Wellness",
      "poi_address": "130 W Columbus Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Relaxed locale for manicures, pedicures and haircuts plus other beauty treatments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d7918-a404-7788-ab4c-db36c114e3f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-a404-7788-ab4c-db36c114e3f7",
        "storage_key": "property/6767906449167348/019d7918-a404-7788-ab4c-db36c114e3f7.webp",
        "width": 1280,
        "height": 487
      },
      "poi_business_url": "http://www.relaxnbs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11897896587662603646&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "relax-nail-bar--salon",
      "poi_latitude": "40.3613361",
      "poi_longitude": "-83.7610115",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 937-404-9010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b1-7f8c-7075-a73b-64f9f69e38b8",
        "storage_key": "property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wmgyTAvP4gRfjX2oejRHaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_447cf9bf-a573-4637-8ae3-3aad67dcb057",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Gloria's Tumbling",
      "poi_type": "Health and Wellness",
      "poi_address": "320 Co Rd 11, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63af-e033-70f6-ad92-702e6a1921b7.webp",
      "poi_featured_image_media": {
        "alt_text": "A young girl stands in the snow in front of a building with a \"Gloria's Tumbling\" sign.",
        "public_id": "019d63af-e033-70f6-ad92-702e6a1921b7",
        "storage_key": "property/6767906449167348/019d63af-e033-70f6-ad92-702e6a1921b7.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7623956660235622779&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glorias-tumbling",
      "poi_latitude": "40.3480002",
      "poi_longitude": "-83.7668453",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 937-441-8365",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f7a-77b6-a95a-3956657e15fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d63b1-7f7a-77b6-a95a-3956657e15fc",
        "storage_key": "property/6767906449167348/019d63b1-7f7a-77b6-a95a-3956657e15fc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrb0ZrYElP4gRe1lRZDC8zWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d41959ca-3431-49ac-b268-cb343de7e507",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "King of Kingz barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "142 W Columbus Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Self-proclaimed barber shop offering haircuts for all ages and hair types.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63af-d73f-729e-a304-4056824cede4.webp",
      "poi_featured_image_media": {
        "alt_text": "Young man with a fade haircut and spiky top",
        "public_id": "019d63af-d73f-729e-a304-4056824cede4",
        "storage_key": "property/6767906449167348/019d63af-d73f-729e-a304-4056824cede4.webp",
        "width": 506,
        "height": 702
      },
      "poi_business_url": "http://book.thecut.co/Mateo-Rosales-mrjf6ae",
      "poi_directions_map_url": "https://maps.google.com/?cid=2834546818756338997&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "king-of-kingz-barbershop",
      "poi_latitude": "40.3614898",
      "poi_longitude": "-83.76134909999999",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 937-876-8090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b1-7f8c-7075-a73b-64f9f69e38b8",
        "storage_key": "property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1zvPV8wvP4gRNWUvR1BVVic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_fbfd11f6-a6d8-4d78-b2d0-1026b79fb0f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Nail Box",
      "poi_type": "Health and Wellness",
      "poi_address": "2115 S Main St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Nail salon offering manicures, pedicures, waxing, eyelash extensions, and facials.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b0-2ec4-7586-9a3c-c0a7ae0b02e8.webp",
      "poi_featured_image_media": {
        "alt_text": "Close-up of decorated fingernails with unique nail art.",
        "public_id": "019d63b0-2ec4-7586-9a3c-c0a7ae0b02e8",
        "storage_key": "property/6767906449167348/019d63b0-2ec4-7586-9a3c-c0a7ae0b02e8.webp",
        "width": 2083,
        "height": 2083
      },
      "poi_business_url": "https://nailboxbellefrontaine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13556047320038977920&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nail-box",
      "poi_latitude": "40.331077",
      "poi_longitude": "-83.7591904",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 937-210-5224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b1-7f8c-7075-a73b-64f9f69e38b8",
        "storage_key": "property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU3szzpUvP4gRgDFP7TbBILw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_f0e62550-fd33-4170-ad90-810706295bec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Mary Rutan Hospital - Mary Rutan Health",
      "poi_type": "Health and Wellness",
      "poi_address": "205 E Palmer Rd, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63af-e804-744a-a631-f9d9a391f0eb.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a modern building with glass and white facade, featuring an entrance and surrounding greenery.",
        "public_id": "019d63af-e804-744a-a631-f9d9a391f0eb",
        "storage_key": "property/6767906449167348/019d63af-e804-744a-a631-f9d9a391f0eb.webp",
        "width": 592,
        "height": 333
      },
      "poi_business_url": "https://www.maryrutan.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2944393088354402656&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mary-rutan-hospital---mary-rutan-health",
      "poi_latitude": "40.3694411",
      "poi_longitude": "-83.75586969999999",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 937-592-4015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f75-75b5-bc80-4c5c776409ec.webp",
      "poi_map_icon_media": {
        "alt_text": "H icon",
        "public_id": "019d63b1-7f75-75b5-bc80-4c5c776409ec",
        "storage_key": "property/6767906449167348/019d63b1-7f75-75b5-bc80-4c5c776409ec.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQy_E1wvP4gRYMF67umV3Cg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4bc99d54-1013-48f7-9041-cd37eeb661c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Community Health and Wellness Partners - Bellefontaine",
      "poi_type": "Health and Wellness",
      "poi_address": "212 E Columbus Ave Suite 1, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b0-3c02-705b-9b54-9c392ae0caab.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of the Community Health & Wellness Partners building with snow on the ground.",
        "public_id": "019d63b0-3c02-705b-9b54-9c392ae0caab",
        "storage_key": "property/6767906449167348/019d63b0-3c02-705b-9b54-9c392ae0caab.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://chwpcares.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8756942514475327098&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "community-health-and-wellness-partners---bellefontaine",
      "poi_latitude": "40.3607477",
      "poi_longitude": "-83.7568172",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 937-599-1411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f75-75b5-bc80-4c5c776409ec.webp",
      "poi_map_icon_media": {
        "alt_text": "H icon",
        "public_id": "019d63b1-7f75-75b5-bc80-4c5c776409ec",
        "storage_key": "property/6767906449167348/019d63b1-7f75-75b5-bc80-4c5c776409ec.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJd3luyBovP4gRel7RFdLohnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_ea9c5153-3795-40ac-81d6-f67a606982a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Lions Club Ball Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "576 Township Rd 174, West Liberty, OH 43357, USA",
      "poi_short_description": "Family-friendly park featuring ball diamond areas, a splash pad and a creek.",
      "poi_long_description": "People say this park offers a splash pad, playground, ball fields, and a walking track. They highlight the park is well-maintained, clean, and has something for everyone, including a creek and river access. They also like the ample parking, restrooms, and accessibility features.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d7918-9ffa-755a-a131-cbc9b77a2808.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-9ffa-755a-a131-cbc9b77a2808",
        "storage_key": "property/6767906449167348/019d7918-9ffa-755a-a131-cbc9b77a2808.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.westlibertylions.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1206427507496786416&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lions-club-ball-park",
      "poi_latitude": "40.2542274",
      "poi_longitude": "-83.74581049999999",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f74-7143-8858-5a2506a49355.webp",
      "poi_map_icon_media": {
        "alt_text": "Illustration of a Christmas tree",
        "public_id": "019d63b1-7f74-7143-8858-5a2506a49355",
        "storage_key": "property/6767906449167348/019d63b1-7f74-7143-8858-5a2506a49355.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRapRDY4wP4gR8BmbF20XvhA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1b9a7a23-98ff-4964-a0f0-eab1008f5a29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Kamp A-Lott",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1888 County Hwy 25 S, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Park with a playground, pool, and community center, as well as ATV rentals and trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-0e8d-70fb-9d2f-cac046f025c8.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a mobile home with a screened-in porch and a car parked in front.",
        "public_id": "019d63b1-0e8d-70fb-9d2f-cac046f025c8",
        "storage_key": "property/6767906449167348/019d63b1-0e8d-70fb-9d2f-cac046f025c8.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://kampalott.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1780333791235668114&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kamp-a-lott",
      "poi_latitude": "40.3515472",
      "poi_longitude": "-83.67783349999999",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 937-599-4504",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f74-7143-8858-5a2506a49355.webp",
      "poi_map_icon_media": {
        "alt_text": "Illustration of a Christmas tree",
        "public_id": "019d63b1-7f74-7143-8858-5a2506a49355",
        "storage_key": "property/6767906449167348/019d63b1-7f74-7143-8858-5a2506a49355.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFyn-XicsP4gRkvg5iCYEtRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3c1fe477-a710-48f1-b6b5-bf748faa676f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Southview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Southview Park, 601 W Lake Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Park offering baseball diamonds and soccer fields, plus basketball courts, a track and playgrounds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b0-49b8-73ac-9403-d39f366274bc.webp",
      "poi_featured_image_media": {
        "alt_text": "Children's playground with slides and climbing structures.",
        "public_id": "019d63b0-49b8-73ac-9403-d39f366274bc",
        "storage_key": "property/6767906449167348/019d63b0-49b8-73ac-9403-d39f366274bc.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9839765159835388574&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southview-park",
      "poi_latitude": "40.3444633",
      "poi_longitude": "-83.7718191",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 937-592-3475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f74-7143-8858-5a2506a49355.webp",
      "poi_map_icon_media": {
        "alt_text": "Illustration of a Christmas tree",
        "public_id": "019d63b1-7f74-7143-8858-5a2506a49355",
        "storage_key": "property/6767906449167348/019d63b1-7f74-7143-8858-5a2506a49355.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKU4bE3glP4gRnspAkUfejYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_009bcb69-8e99-48e0-a9cb-93b780ae3d55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Kaliedoscope Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "401-429 E Williams Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Recreational area with a playground, picnic tables, basketball and tennis courts, and disc golf.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b0-3f28-7296-ab32-15838772d81a.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground area with slides, swings, and climbing structures.",
        "public_id": "019d63b0-3f28-7296-ab32-15838772d81a",
        "storage_key": "property/6767906449167348/019d63b0-3f28-7296-ab32-15838772d81a.webp",
        "width": 2992,
        "height": 2992
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12890887041243194454&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaliedoscope-park",
      "poi_latitude": "40.3666376",
      "poi_longitude": "-83.7500201",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f74-7143-8858-5a2506a49355.webp",
      "poi_map_icon_media": {
        "alt_text": "Illustration of a Christmas tree",
        "public_id": "019d63b1-7f74-7143-8858-5a2506a49355",
        "storage_key": "property/6767906449167348/019d63b1-7f74-7143-8858-5a2506a49355.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcaR25EIvP4gRVqT8FHeh5bI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c0b52aad-d395-4899-8d61-427c375bc7b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Lewis Ratleff Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 S Springhill St, Bellefontaine, OH 43311, USA",
      "poi_short_description": "Park, playground, and baseball field at which kids can play games and have fun.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d7918-a713-71ac-b50d-b34448480f1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-a713-71ac-b50d-b34448480f1d",
        "storage_key": "property/6767906449167348/019d7918-a713-71ac-b50d-b34448480f1d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17158852839965938738&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lewis-ratleff-park",
      "poi_latitude": "40.3588008",
      "poi_longitude": "-83.77606709999999",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f74-7143-8858-5a2506a49355.webp",
      "poi_map_icon_media": {
        "alt_text": "Illustration of a Christmas tree",
        "public_id": "019d63b1-7f74-7143-8858-5a2506a49355",
        "storage_key": "property/6767906449167348/019d63b1-7f74-7143-8858-5a2506a49355.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0zyLBmklP4gRMlRfF799IO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1cb79120-92a3-4f72-a816-1e349f8ae8a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Bellefontaine Regional Airport-EDJ",
      "poi_type": "Transportation & Transit",
      "poi_address": "3100 OH-47, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b0-6c03-72cc-b18b-a874b11e63f0.webp",
      "poi_featured_image_media": {
        "alt_text": "A man poses for a photo next to a small private plane on an airfield.",
        "public_id": "019d63b0-6c03-72cc-b18b-a874b11e63f0",
        "storage_key": "property/6767906449167348/019d63b0-6c03-72cc-b18b-a874b11e63f0.webp",
        "width": 1414,
        "height": 743
      },
      "poi_business_url": "http://www.ci.bellefontaine.oh.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11221199920485297547&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bellefontaine-regional-airport-edj",
      "poi_latitude": "40.37015170000001",
      "poi_longitude": "-83.81766909999999",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 937-593-8210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f89-710b-868f-f8e5d944c213.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019d63b1-7f89-710b-868f-f8e5d944c213",
        "storage_key": "property/6767906449167348/019d63b1-7f89-710b-868f-f8e5d944c213.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_KrbDkkP4gRi-0qDuC1uZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_af17c800-6485-434d-b5bd-e9c7b6d58ef9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "poi_name": "Thermoid",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1301 W Sandusky Ave, Bellefontaine, OH 43311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b0-b90c-744c-98a7-76412ab8a43a.webp",
      "poi_featured_image_media": {
        "alt_text": "Truck and trailer at a loading dock.",
        "public_id": "019d63b0-b90c-744c-98a7-76412ab8a43a",
        "storage_key": "property/6767906449167348/019d63b0-b90c-744c-98a7-76412ab8a43a.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.thermoid.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12020562900511707913&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thermoid",
      "poi_latitude": "40.3609161",
      "poi_longitude": "-83.78540029999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-543-8070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d63b1-7f8c-7075-a73b-64f9f69e38b8",
        "storage_key": "property/6767906449167348/019d63b1-7f8c-7075-a73b-64f9f69e38b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYd90mJUlP4gRCVM9NUWe0aY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_b965cc49-35e2-45be-bab3-5c387d4a0011",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "day": "MON",
      "open_time": "08:00",
      "close_time": "16:00"
    },
    {
      "id": "custom_2228047b-2d47-40bc-af62-c3658760c05f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "day": "TUE",
      "open_time": "08:00",
      "close_time": "16:00"
    },
    {
      "id": "custom_90937c4b-5fae-45bf-87f0-1199c80e14ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "day": "WED",
      "open_time": "08:00",
      "close_time": "16:00"
    },
    {
      "id": "custom_ef534c20-7e17-4fd9-abbf-893f6043df58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "day": "THU",
      "open_time": "08:00",
      "close_time": "16:00"
    },
    {
      "id": "custom_6fe234a0-6128-46f8-b294-4d43af3e296a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "day": "FRI",
      "open_time": "08:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e1ddc-6520-774a-9929-03002a27d4e3",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "bsa---brookstone-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348"
    },
    {
      "lead_collector_id": "019e1ddc-658f-73eb-a080-82351a7f29fb",
      "lead_source": "FACEBOOK_ADS",
      "name": "bsa---brookstone-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348"
    },
    {
      "lead_collector_id": "019e1ddc-6605-748b-ba07-a8770eabf933",
      "lead_source": "LANDING_PAGE",
      "name": "bsa---brookstone-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-bellefontaine-oh",
      "search_query": "pet friendly apartments Bellefontaine OH",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Bellefontaine, OH",
      "h2_subtitle": "Discover the best pet friendly apartments. Brookstone Apartments offers a welcoming environment for you and your furry friends in Bellefontaine, OH.",
      "page_copy": "Embrace a pet-friendly lifestyle at Brookstone Apartments in Bellefontaine, OH. Our community welcomes four-legged companions, ensuring everyone can enjoy our delightful amenities. Unwind on your private balcony while your pets explore the neighborhood, or take them for a walk around our thoughtfully designed grounds. With spacious two and three-bedroom homes and amenities like controlled access and a playground, both you and your furry friends will feel right at home.\n\nOur on-site professional management team is committed to making sure you and your pet feel comfortable and cared for. Located in the Ohio South area, Brookstone Apartments combines convenience and charm, providing high-speed internet and black appliances in every unit. Choose Brookstone Apartments for the perfect mix of pet-friendly features and a vibrant living environment in Bellefontaine, OH.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and green lawn.",
        "public_id": "019d63b1-674b-7546-b5ab-4baef2fe557e",
        "storage_key": "property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
        "width": 2048,
        "height": 1151
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Bellefontaine, OH",
      "seo_description": "Find pet friendly apartments at Brookstone in Bellefontaine, OH. Enjoy ample amenities and a welcoming community. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "page_item_url": "apartments-with-balconies-logan-county",
      "search_query": "apartments with balconies Logan County",
      "category": "Amenity",
      "h1_title": "Apartments with Balconies in Logan County",
      "h2_subtitle": "Enjoy expansive balconies at Brookstone Apartments. Our Logan County location offers scenic views and modern living in Bellefontaine, OH.",
      "page_copy": "Brookstone Apartments, located in the heart of Logan County, offers exceptional living with spacious balconies perfect for relaxation and enjoyment. Our two and three-bedroom homes in Bellefontaine, OH, come equipped with generous balconies, providing an ideal outdoor space to unwind after a busy day. Savor the serene views and fresh air as you settle into your new vibrant living environment.\n\nIn addition to the stunning balconies, our community offers a range of amenities to enhance your lifestyle. From laundry facilities to a playful playground, we cater to every resident's needs. With professional management and ideal location in Logan County, Brookstone Apartments delivers an unmatched living experience. Discover the perfect blend of comfort and convenience with us today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and green lawn.",
        "public_id": "019d63b1-674b-7546-b5ab-4baef2fe557e",
        "storage_key": "property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
        "width": 2048,
        "height": 1151
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Balconies in Logan County",
      "seo_description": "Experience Logan County living at Brookstone. Spacious balconies, modern amenities, and a prime location await in Bellefontaine, OH.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "page_item_url": "playground-apartments-ohio-south-area",
      "search_query": "playground apartments in Ohio South Area",
      "category": "Amenity",
      "h1_title": "Playground Apartments in Ohio South Area",
      "h2_subtitle": "Find apartments with a playground at Brookstone. Located in Ohio South Area, our property ensures community-friendly fun with ample amenities.",
      "page_copy": "Located in the lively Ohio South Area, Brookstone Apartments offers a welcoming haven with a delightful playground for those with children. Our two and three-bedroom homes in Bellefontaine, OH, make it easy for children to have fun and stay active. With controlled access and professional management, you will feel assured that safety is a top priority while enjoying the vibrant community amenities.\n\nAt Brookstone Apartments, residents benefit from more than just our well-equipped playground. The community features modern conveniences such as laundry facilities, high-speed internet, and spacious balconies, making day-to-day life a breeze. Choose Brookstone for the ideal community-friendly experience in the Ohio South Area, where great adventure and comfort meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and green lawn.",
        "public_id": "019d63b1-674b-7546-b5ab-4baef2fe557e",
        "storage_key": "property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
        "width": 2048,
        "height": 1151
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Playground Apartments in Ohio South Area",
      "seo_description": "Enjoy community-friendly living with a playground at Brookstone Apartments in the Ohio South Area, Bellefontaine, OH. Contact us today for a tour!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-bellefontaine-43311",
      "search_query": "air conditioned apartments Bellefontaine 43311",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Bellefontaine",
      "h2_subtitle": "Stay cool in air conditioned comfort at Brookstone Apartments. Experience relaxed living in Bellefontaine, OH 43311.",
      "page_copy": "At Brookstone Apartments in Bellefontaine, OH, our air conditioned apartments ensure a comfortable living environment in any season. Situated in the 43311 area, our modern two and three-bedroom homes offer a sanctuary where you can escape the summer heat. With state-of-the-art air conditioning, you can enjoy the perfect indoor climate year-round.\n\nBeyond comfort, Brookstone Apartments provides a suite of amenities, including spacious balconies, high-speed internet, and a playful playground, all under the watchful care of our professional management team. Experience unparalleled living in a community that combines convenience and comfort in the heart of Bellefontaine. Discover why air conditioned living at Brookstone is the best choice for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and green lawn.",
        "public_id": "019d63b1-674b-7546-b5ab-4baef2fe557e",
        "storage_key": "property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
        "width": 2048,
        "height": 1151
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Bellefontaine",
      "seo_description": "Cool off in air conditioned apartments at Brookstone, located in the Bellefontaine 43311 area. Enjoy modern amenities and comfort today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "page_item_url": "apartments-with-dishwasher-logan-county",
      "search_query": "apartments with dishwasher Logan County",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Logan County",
      "h2_subtitle": "Discover apartment living with dishwashers at Brookstone. Our Logan County community offers modern amenities in Bellefontaine, OH.",
      "page_copy": "Brookstone Apartments in Bellefontaine, OH, offers a seamless living experience in Logan County with apartments equipped with dishwashers. Our thoughtfully designed two and three-bedroom homes ensure convenience, allowing you more time to relax and enjoy your surroundings. Revel in modern kitchen facilities that make mealtime cleanup effortless.\n\nIn addition to having a dishwasher, our community provides an array of amenities such as generous balconies, a playground, and laundry facilities. Set in the picturesque Logan County, Brookstone Apartments combine comfort with ease, all provided under the care of our professional management team. Choose a lifestyle that caters to both convenience and relaxation at Brookstone today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and green lawn.",
        "public_id": "019d63b1-674b-7546-b5ab-4baef2fe557e",
        "storage_key": "property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
        "width": 2048,
        "height": 1151
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in Logan County",
      "seo_description": "Brookstone offers dishwashers in their Logan County apartments. Located in Bellefontaine with modern amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-bellefontaine-oh",
      "search_query": "two bedroom apartments bellefontaine oh",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Bellefontaine, OH",
      "h2_subtitle": "Explore spacious two bedroom apartments at Brookstone in Bellefontaine. Perfect for modern living, with exceptional amenities and a great location.",
      "page_copy": "Discover the ideal two bedroom apartments at Brookstone Apartments, nestled in the heart of Bellefontaine, OH. Our spacious layouts provide the perfect balance of comfort and style, ideal for young professionals, or anyone seeking a modern living space. Enjoy the convenience of thoughtfully designed interiors that cater to your lifestyle needs.\n\nBrookstone not only delivers on space but also offers a suite of amenities including high-speed internet, expansive balconies, and a community-friendly playground. Managed by a professional team, our community ensures that residents experience seamless, enjoyable living. Immerse yourself in the vibrant neighborhood of Bellefontaine and make Brookstone Apartments your home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and green lawn.",
        "public_id": "019d63b1-674b-7546-b5ab-4baef2fe557e",
        "storage_key": "property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
        "width": 2048,
        "height": 1151
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Bellefontaine, OH",
      "seo_description": "Find spacious two bedroom apartments at Brookstone in Bellefontaine, OH. Experience comfort, style, and convenience with modern amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-logan-county",
      "search_query": "three bedroom apartments logan county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Logan County",
      "h2_subtitle": "Spacious three bedroom apartments available in Logan County. Discover exceptional living at Brookstone Apartments in Bellefontaine.",
      "page_copy": "Brookstone Apartments in Bellefontaine, OH, offer expansive three bedroom apartments perfect for roommates, or those needing extra space in Logan County. Our well-designed homes provide the perfect setting for both relaxation and entertaining, with ample room and modern finishes to complement any lifestyle.\n\nResidents of Brookstone can take advantage of our impressive array of amenities, including laundry facilities, controlled access, and a welcoming playground. Our professional management team ensures a safe and pleasant living environment, making your experience in Logan County truly exceptional. Discover the perfect blend of comfort, convenience, and community at Brookstone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and green lawn.",
        "public_id": "019d63b1-674b-7546-b5ab-4baef2fe557e",
        "storage_key": "property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
        "width": 2048,
        "height": 1151
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Logan County",
      "seo_description": "Explore spacious three bedroom apartments at Brookstone in Logan County. Experience great amenities and a welcoming community. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "page_item_url": "apartments-near-mary-rutan-hospital-bellefontaine-oh",
      "search_query": "apartments near Mary Rutan Hospital Bellefontaine OH",
      "category": "Hospital",
      "h1_title": "Apartments Near Mary Rutan Hospital",
      "h2_subtitle": "Find convenient living near Mary Rutan Hospital at Brookstone Apartments in Bellefontaine, OH. Enjoy top amenities and a welcoming community.",
      "page_copy": "Brookstone Apartments, located conveniently in Bellefontaine, OH, offer ideal living close to Mary Rutan Hospital. Perfect for healthcare professionals, patients, and visitors alike, our thoughtfully designed two and three-bedroom homes provide easy access to the hospital while ensuring a comfortable living experience.\n\nOur community features a host of amenities, including high-speed internet, welcoming balconies, and a fun playground, making it the perfect place to unwind after a busy day. Nestled in a serene setting in Bellefontaine, Brookstone Apartments harmonize convenience and comfort, providing a seamless lifestyle near Mary Rutan Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and green lawn.",
        "public_id": "019d63b1-674b-7546-b5ab-4baef2fe557e",
        "storage_key": "property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
        "width": 2048,
        "height": 1151
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mary Rutan Hospital, Bellefontaine",
      "seo_description": "Live near Mary Rutan Hospital at Brookstone Apartments in Bellefontaine, OH. Enjoy modern amenities and a convenient location. Explore today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "page_item_url": "brookstone-apartments-near-lions-club-ball-park-bellefontaine",
      "search_query": "brookstone apartments near lions club ball park bellefontaine",
      "category": "Park",
      "h1_title": "Brookstone Apartments Near Lions Club Ball Park",
      "h2_subtitle": "Discover Brookstone Apartments located near Lions Club Ball Park in Bellefontaine. Enjoy a community rich with amenities and nearby recreational spots.",
      "page_copy": "Experience comfortable and convenient living at Brookstone Apartments, just a stone's throw away from Lions Club Ball Park in Bellefontaine. Ideal for sports enthusiasts and nature lovers, our two and three-bedroom homes offer easy access to one of the city's cherished recreational areas, perfect for outdoor activities and community events.\n\nBrookstone Apartments not only promise a prime location but also complement it with exceptional amenities like high-speed internet, generous balconies, and a playful playground. Whether you're spending the day at the park or relaxing at home, Brookstone offers the perfect blend of community and solitude, ensuring a fulfilling lifestyle in Bellefontaine.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and green lawn.",
        "public_id": "019d63b1-674b-7546-b5ab-4baef2fe557e",
        "storage_key": "property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
        "width": 2048,
        "height": 1151
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Brookstone Apartments by Lions Club Ball Park",
      "seo_description": "Live at Brookstone Apartments near Lions Club Ball Park in Bellefontaine, OH. Enjoy great amenities and proximity to recreational spaces. Discover more!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "page_item_url": "living-near-kamp-a-lott-ohio-south-area",
      "search_query": "living near kamp a-lott ohio south area",
      "category": "Park",
      "h1_title": "Living Near Kamp-A-Lott in Ohio South Area",
      "h2_subtitle": "Experience the charm of living near Kamp-A-Lott in the Ohio South Area. Brookstone Apartments offer a welcoming community and modern amenities.",
      "page_copy": "Nestled in the scenic Ohio South Area, Brookstone Apartments offer the perfect setting for those looking to enjoy living near Kamp-A-Lott. Our welcoming community provides easy access to the great outdoors, making it an ideal choice for those who appreciate nature and outdoor activities.\n\nBrookstone Apartments feature thoughtfully designed two and three-bedroom homes, complemented by amenities such as laundry facilities, high-speed internet, and controlled access. Residents can enjoy a peaceful atmosphere with a playground and expansive balconies, all under the attentive care of our professional management team, making life near Kamp-A-Lott both comfortable and convenient.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and green lawn.",
        "public_id": "019d63b1-674b-7546-b5ab-4baef2fe557e",
        "storage_key": "property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
        "width": 2048,
        "height": 1151
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Kamp-A-Lott, Ohio South Area",
      "seo_description": "Discover living near Kamp-A-Lott in the Ohio South Area at Brookstone Apartments. Enjoy modern living with great amenities. Explore more today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "page_item_url": "kaliedoscope-park-close-to-brookstone-apartments-43311",
      "search_query": "kaliedoscope park close to brookstone apartments 43311",
      "category": "Park",
      "h1_title": "Explore Kaliedoscope Park Near Brookstone",
      "h2_subtitle": "Kaliedoscope Park is just minutes from Brookstone Apartments in the 43311 area. Enjoy convenient access to this vibrant outdoor spot.",
      "page_copy": "Brookstone Apartments in Bellefontaine, OH, offer an exceptional living experience with the added benefit of being close to Kaliedoscope Park. This local gem provides a vibrant escape into nature, perfect for leisurely walks and family outings.\n\nResidents of Brookstone Apartments, located in the 43311 zip code, can enjoy spacious two and three-bedroom homes, complete with modern amenities such as black appliances and controlled access. Coupled with the nearby park, our community offers an ideal blend of tranquility and activity, ensuring a fulfilling lifestyle right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and green lawn.",
        "public_id": "019d63b1-674b-7546-b5ab-4baef2fe557e",
        "storage_key": "property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
        "width": 2048,
        "height": 1151
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Kaliedoscope Park Near Brookstone Apartments",
      "seo_description": "Live near Kaliedoscope Park at Brookstone Apartments in Bellefontaine, OH 43311. Enjoy local amenities and explore vibrant outdoor spaces. Learn more now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167348",
      "source": "custom",
      "page_item_url": "apartments-near-lewis-ratleff-park-logan-county",
      "search_query": "apartments near lewis ratleff park logan county",
      "category": "Park",
      "h1_title": "Apartments Near Lewis Ratleff Park",
      "h2_subtitle": "Discover the convenience of living near Lewis Ratleff Park at Brookstone Apartments in Logan County. Experience a community enriched with amenities.",
      "page_copy": "Enjoy the perfect combination of comfort and convenience at Brookstone Apartments, situated near the scenic Lewis Ratleff Park in Logan County. This location is ideal for those who enjoy outdoor recreation, with the park offering numerous activities and green spaces just a short distance from your doorstep.\n\nBrookstone Apartments provide spacious two and three-bedroom homes, thoughtfully equipped with amenities like generous balconies, high-speed internet, and a playground. Combined with our controlled access and black appliances, the community ensures a seamless living experience, making it an excellent choice for those wanting proximity to Lewis Ratleff Park and the vibrant local environment in Logan County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and green lawn.",
        "public_id": "019d63b1-674b-7546-b5ab-4baef2fe557e",
        "storage_key": "property/6767906449167348/019d63b1-674b-7546-b5ab-4baef2fe557e.webp",
        "width": 2048,
        "height": 1151
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lewis Ratleff Park, Logan County",
      "seo_description": "Find comfort near Lewis Ratleff Park at Brookstone Apartments in Logan County. Discover community amenities and a prime location today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6279"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11680149691"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5098665"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WCVVJ933"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Prestige"
    },
    {
      "ID": "custom_realpage_tour_widget",
      "type": "STRING",
      "value": "<script src=\"https://cs-cdn.realpage.com/CAL/v1.0/cs-calendar-widget.min.js\"></script> <script>var calendar = new csCalendar(\"2M8196674280\")</script>"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlRKeVJYUSt2cEs0MEgvcnI3WDlyclE9PSIsInZhbHVlIjoiTmxJZWR3b0NzQWg4Q1hKNnRlMHJ3QT09IiwibWFjIjoiNzI0ODE1ODRmNmE5NDRiYzg0MWViZTE4OGU2N2VhMWZhOWZjNjFjMWIxYWJiYmUyY2ZmY2I0MjU5MmQzYWVhZSJ9"
    }
  ],
  "custom_qb_id": "6279",
  "custom_repli_id": "11680149691",
  "custom_realpage_id": "5098665",
  "custom_google_gtm_id": "GTM-WCVVJ933",
  "custom_rollout_phase": "Phase 2",
  "custom_vibesites_theme": "Prestige",
  "custom_realpage_tour_widget": "<script src=\"https://cs-cdn.realpage.com/CAL/v1.0/cs-calendar-widget.min.js\"></script> <script>var calendar = new csCalendar(\"2M8196674280\")</script>",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlRKeVJYUSt2cEs0MEgvcnI3WDlyclE9PSIsInZhbHVlIjoiTmxJZWR3b0NzQWg4Q1hKNnRlMHJ3QT09IiwibWFjIjoiNzI0ODE1ODRmNmE5NDRiYzg0MWViZTE4OGU2N2VhMWZhOWZjNjFjMWIxYWJiYmUyY2ZmY2I0MjU5MmQzYWVhZSJ9",
  "custom_audioeye_site_id": "2efc9907-9df0-45a7-b5ad-8637c62bfa04",
  "custom_audioeye_site_hash": "abe23466fdbf69e701aca9299bc50c8e"
};

export const generatedAt = '2026-09-23T21:56:39.430Z';
